import React, { useState, useEffect } from "react";
import { getTriviaFileName, WEB_GENERATE_ERROR_MESSAGE } from "../../data";
import {
  Button,
  Col,
  Popover,
  Row,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { BsDownload, BsEye, BsThreeDots } from "react-icons/bs";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../../axios";
import { toastContainer } from "../../../../utils/toast";
import * as url from "../../../../utils/url";
import { CSVLink } from "react-csv";
import { isMobile } from "../../../../utils/deviceInfo";
import { FaRecycle } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa";
import * as actionCreators from "../../../../modules/actions";

function SidebarComponent({
  libraryQuestions = [],
  library,
  libraryTrivvyCount,
  libraryQuestionsCount,
  updateLibraryDoc,
  setGenerateSummaryLoader
}) {
  const [showMore, setShowMore] = useState(false);
  const [customTextModal, setCustomTextModal] = useState(false);
  const [summaryModalText, setSummaryModalText] = useState(false);
  const [summaryLoading,setSummaryLoading] = useState(false)

  const getDataForQuestionsExports = (questions) => {
    const data = questions.map((que) => {
      return {
        question: que.questionText,
        createdOn: moment(que.createdOn).format("MMM DD, YYYY"),
        triviaPart: que.triviaPart > 0 ? que.triviaPart : "N/A",
        options:
          que.questionType === "MCQ" && que.options
            ? `${que.options.map((option, idx) => {
                return `${idx + 1}- ${option}`;
              })}`
            : "",
        answer: que.answer || "",
        source: que.source || "",
      };
    });

    return data;
  };

  const libraryQuestionsHeaders = [
    {
      label: "Question",
      key: "question",
    },
    {
      label: "Created Date",
      key: "createdOn",
    },
    {
      label: "Trivvy Part",
      key: "triviaPart",
    },
    {
      label: "Options",
      key: "options",
    },
    {
      label: "Source",
      key: "source",
    },
    {
      label: "Answer",
      key: "answer",
    },
  ];

  const remainingUi = () => {
    return (
      <div>
        {" "}
        {library && library.userId && library.userId.firstName ? (
          <div className="libSidebarAbout pl-2">
            <span>uploaded by </span>{" "}
            <span>
              {library.userId.firstName} {library.userId.lastName}{" "}
              {library.uploadDate
                ? `on ${moment(library.uploadDate).format("MMM DD, YYYY")}`
                : ""}
            </span>
          </div>
        ) : (
          ""
        )}
        {/* <div className="my-3 libSidebarAbout pl-2">
          Question count: {libraryQuestionsCount}
        </div> */}
        <div className="my-3 libSidebarAbout pl-2">
          Trivvy count: {libraryTrivvyCount}
        </div>
        <div className="mt-4 pl-2 mb-3">
          {libraryQuestions && libraryQuestions.length ? (
            <div className="mt-0 text-info libSidebarAbout pl-0">
              <CSVLink
                data={getDataForQuestionsExports(libraryQuestions)}
                headers={libraryQuestionsHeaders}
                filename={`${getTriviaFileName({
                  uploadUrl: library.s3Url,
                  uploadFileName: library.s3Key,
                  librarySourceType: library.librarySourceType,
                  libName: library.name,
                  webUrl:library.webUrl
                })} Questions-${moment().format("MM/DD/YYYY")}.csv`}
                separator={","}
                target="_blank"
                className=""
                style={{
                  height: "fit-content",
                }}
              >
                {"Download questions"} <BsDownload size={13} />
              </CSVLink>
            </div>
          ) : (
            ""
          )}
        </div>

        <div>
          {library.summaryText ? (
            <Button
              onClick={() => {
                setSummaryModalText(library.summaryText);
              }}
              size="sm"
              color="primary"
              className="ml-2"
            >
              View summary <BsEye />
            </Button>
          ) : (
            <div>
              {
                summaryLoading ?   <Button className="trivia-action-button-main" disabled>Generating... <FaSpinner className="ml-2" /> </Button>  : <Button className="trivia-action-button-main" onClick={()=>generateSummary(library)}>Generate summary <FaRecycle /> </Button>
              }
            </div>
         
          )}
        </div>
      </div>
    );
  };

  const generateSummary = (item) => {
    setSummaryLoading(true)
    const nextFunc = (data)=>{
      setSummaryLoading(false)
      updateLibraryDoc(data)
    }
    const payload = {
      content: item.librarySourceType == 0 ? item.webUrl:  item.librarySourceType == 2 ? item.text : item.s3Url,
      contentType:item.librarySourceType == 0 ? "LINK":  item.librarySourceType == 2 ? "TEXT" : "LINK",
      _id:item._id,
      cb:nextFunc
    }

    setGenerateSummaryLoader({
      display:true,
      minimize:false,
      loaderApiData:payload
    })
  };

  const handleLibrary = (item) => {
    if (item.librarySourceType == 0 && item.webUrl) {
      window.open(item.webUrl, "new");
    } else if (item.librarySourceType == 2 && item.text) {
      setCustomTextModal(item.text);
    } else {
      window.open(item.s3Url, "new");
    }
  };
  return (
    <Col sm={2} className="TriviaEditViewListUI_leftContainer py-2 p-0 pl-2">
      {customTextModal && (
        <Modal isOpen={true}>
          <ModalHeader
            toggle={() => {
              setCustomTextModal(false);
            }}
            className="trivia_modal_header_bg"
          >
            Custom Text
          </ModalHeader>
          <ModalBody>{customTextModal}</ModalBody>
        </Modal>
      )}
      <div className="px-4  mt-4 ">
        <div className="my-3 libSidebarAbout pl-2">
          Name:
          <span
            className="text-info cursor-pointer"
            onClick={() => handleLibrary(library)}
          >
            {getTriviaFileName({
              uploadUrl: library.s3Url,
              uploadFileName: library.s3Key,
              showFull: true,
              librarySourceType: library.librarySourceType,
              libName: library.name,
            })}{" "}
            (view)
          </span>
        </div>

        {isMobile ? (
          <div className="">
            {showMore && remainingUi()}
            {showMore ? (
              <div
                className={`${
                  isMobile ? "pl-2" : ""
                }  cursor-pointer font-weight-bold`}
                onClick={() => setShowMore(false)}
              >
                Show less -
              </div>
            ) : (
              <div
                className="pl-2 cursor-pointer font-weight-bold"
                onClick={() => setShowMore(true)}
              >
                Show more +
              </div>
            )}
          </div>
        ) : (
          remainingUi()
        )}

        {summaryModalText && (
          <Modal isOpen={true}>
            <ModalHeader
              toggle={() => {
                setSummaryModalText(false);
              }}
              className="trivia_modal_header_bg"
            >
              Summary
            </ModalHeader>
            <ModalBody>{summaryModalText}</ModalBody>
          </Modal>
        )}

       
      </div>
      {/* TriviaEditViewListUI_leftContainer_content TriviaEditViewListUI_leftContainer_content_extendLibSidebar px-2 pt-2 */}
    </Col>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    libraryTrivvyCount:
      state.trivia && state.trivia.singleLibraryStats
        ? state.trivia.singleLibraryStats.trivvyCount
        : 0,
    libraryQuestionsCount:
      state.trivia && state.trivia.singleLibraryStats
        ? state.trivia.singleLibraryStats.questionsCount
        : 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGenerateSummaryLoader: (data) =>
    dispatch(actionCreators.setGenerateSummaryLoader(data)),
  }

};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarComponent);
